import type { ComponentType } from "react";
import { Link } from "react-router-dom";
import { FacebookIcon, InstagramIcon, LinkedInIcon, XIcon, YouTubeIcon } from "./icons";
import "./marketing.css";

type FooterLink = { label: string; to?: string; href?: string };

const COLUMNS: { title: string; links: FooterLink[] }[] = [
  {
    title: "Product",
    links: [
      { label: "For Agents", to: "/agents" },
      { label: "For Teams & Brokerages", to: "/teams-brokerages" },
      { label: "Pricing", to: "/pricing" },
      { label: "How It Works", to: "/agents" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Press", to: "/press" },
      { label: "Contact", href: "mailto:hello@compaire.co" },
    ],
  },
  {
    // Anonymity Promise and Data Handling are omitted until they have real
    // destinations; the previous footer linked them to "#".
    title: "Legal & Trust",
    links: [
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms of Service", to: "/terms" },
    ],
  },
];

const SOCIALS: { label: string; href: string; Icon: ComponentType<{ size?: number }> }[] = [
  { label: "LinkedIn", href: "https://www.linkedin.com/company/joincompaire", Icon: LinkedInIcon },
  { label: "Instagram", href: "https://www.instagram.com/joincompaire", Icon: InstagramIcon },
  { label: "Facebook", href: "https://www.facebook.com/joincompaire", Icon: FacebookIcon },
  { label: "YouTube", href: "https://www.youtube.com/@JoinCompaire", Icon: YouTubeIcon },
  { label: "X", href: "https://x.com/joincompaire", Icon: XIcon },
];

/** Marketing-site footer (v3.3): white, auto-fit columns, five social squares. */
const MarketingFooter = () => (
  <footer className="mk-footer">
    <div className="mk-footer__inner">
      <div className="mk-footer__grid">
        <div className="mk-footer__brand">
          <Link to="/" className="mk-footer__logo" aria-label="Compaire home">
            <img src="/compaire-logo.svg" alt="" width={240} height={22} />
          </Link>
          <div className="mk-footer__socials">
            {SOCIALS.map(({ label, href, Icon }) => (
              <a
                key={label}
                href={href}
                aria-label={label}
                className="mk-footer__social"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon size={20} />
              </a>
            ))}
          </div>
        </div>
        {COLUMNS.map((column) => (
          <nav key={column.title} className="mk-footer__col" aria-label={column.title}>
            <h2 className="mk-footer__title">{column.title}</h2>
            <ul className="mk-footer__links">
              {column.links.map((link) => (
                <li key={link.label}>
                  {link.to ? <Link to={link.to}>{link.label}</Link> : <a href={link.href}>{link.label}</a>}
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>
      <div className="mk-footer__bottom">
        <span>© 2026 Compaire. All rights reserved.</span>
        <span>Built for the next generation of real estate professionals.</span>
      </div>
    </div>
  </footer>
);

export default MarketingFooter;
